module.exports = __webpack_public_path__ + "static/media/logo-white.b26c9ae9.svg";